import React, { Component } from 'react';
import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import '../../FundMonitoring.css';
class TradesReviewGrid extends Component {
    constructor(props) {
        super(props);

        this.state = {
            columnDefs: props.tradesReviewGridColumns,
            defaultColDef: {
                enableCellChangeFlash: true,
                minWidth: 100,
                sortable: true,
                filter: true,
                resizable: true,
            },
            sideBar: {
                toolPanels: ['columns', 'filters'],
                defaultToolPanel: '',
            },
            groupDefaultExpanded: 0,
        };
    }


    onGridReady = grid => {
        this.props.addTradesReviewGridToProps(grid);
    }

    getRowClass = (() => {
        // 闭包变量，记录上一�?Ticker 和当前颜�?
        let lastTicker = null;
        let currentColor = 0;
        return (params) => {
            const { contrarian } = this.props.tradesReviewSearchFields || {};
            if (!contrarian) return '';
            const ticker = params.data.ticker;
            if (ticker !== lastTicker) {
                currentColor = 1 - currentColor; // 颜色切换
                lastTicker = ticker;
            }
            return currentColor === 0 ? 'piano-row-even' : 'piano-row-odd';
        };
    })()

    render() {
        const {
            queryTradesReviewActionStatus,
            queryTradesReviewActionResp,
        } = this.props;

        const isLoading = queryTradesReviewActionStatus === ACTION_STATUS.LOGINING;
        let dataArray = [];
        if (queryTradesReviewActionResp !== undefined && queryTradesReviewActionResp !== null && queryTradesReviewActionResp.respCode === 'S0001') {
            dataArray = queryTradesReviewActionResp.data;
        }


        return (
            <div className={`ag-theme-balham grid-wrapper`}>
                {isLoading ? (
                    <Loader active content="Loading..." />
                ) : (
                    <AgGridReact
                        // properties
                        columnDefs={this.state.columnDefs}
                        rowData={dataArray}
                        defaultColDef={this.state.defaultColDef}
                        rowSelection={this.state.rowSelection}
                        // rowClassRules={this.state.rowClassRules}
                        animateRows={true}
                        immutableData={false}
                        resizable={true}
                        sideBar={this.state.sideBar}
                        getRowNodeId={this.getRowNodeId}
                        // event
                        onGridReady={this.onGridReady}
                        getRowClass={this.getRowClass}
                    />
                )}
            </div>
        );
    }

}

export default TradesReviewGrid;



